module.exports = __webpack_public_path__ + "static/media/redux.f5b82ca2.jpg";